import Ripple from "../../components/Ripple";
import React, { type DetailedHTMLProps, type HTMLAttributes } from "react";
import { Link } from "react-router-dom";
import { generateKey } from "../../utils/helpers";

export interface ContextMenuItem {
  icon?: string | React.ReactElement;
  image?: string | React.ReactElement;
  text?: string;
  link?: string;
  element?: React.ReactElement;
  customElement?: React.ReactElement;
  bold?: boolean;
  separator?: boolean;
  hide?: boolean;
  onClick?: () => any;
  a?: boolean;
  wrap?: boolean;
}

type ContextMenuProps = DetailedHTMLProps<
  HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  items: ContextMenuItem[];
};

const ContextMenuList: React.FC<ContextMenuProps> = ({
  items,
  ...divProps
}) => {
  const filteredItems = items.filter((i) => !i.hide);

  return (
    <group data-max-length="300" {...divProps}>
      <div className="list_menu">
        <ul>
          {filteredItems.map((item, index) => {
            let element;

            if (item.separator) {
              if (index === filteredItems.length - 1 || index === 0) {
                return null;
              }

              return <li key={generateKey()} className="separator"></li>;
            } else if (item.customElement) {
              return (
                <React.Fragment key={generateKey()}>
                  {item.customElement}
                </React.Fragment>
              );
            } else if (item.element) {
              element = item.element;
            } else {
              element = (
                <>
                  {item.image ? item.image : <icon data-length="30" data-height="30">{item.icon ?? ""}</icon>}
                  {item.text && <text
                    data-weight={item.bold ? "700" : undefined}
                    data-wrap={item.wrap ? "wrap" : undefined}
                  >
                    {item.text}
                  </text>}
                </>
              );

              if (item.link) {
                if (item.a) {
                  element = <a href={item.link}>{element}</a>;
                } else {
                  element = <Link to={item.link}>{element}</Link>;
                }
              }
            }

            return (
              <Ripple key={generateKey()}>
                <li
                  data-radius="5"
                  data-gap="5"
                  onClick={item.onClick} //NOSONAR
                >
                  {element}
                </li>
              </Ripple>
            );
          })}
        </ul>
      </div>
    </group>
  );
};

export default ContextMenuList;
